/**
 * 
 * @param {vuex实例} store 
 * @param {qiankun下发的props} props 
 */

function registerGlobalModule(store, props = {}) {
    if (!store || !store.hasModule) {
        return;
    }
    // 获取初始化的state
    // const gateway = props.gateway || '';
    // const initState = props.getGlobalState && props.getGlobalState();
    // const initState = props;
    const globalModule = {
        namespaced: true,
        state: {
            props,
            // ...initState,
            // gateway
        },
        actions: {
            // 子应用改变state并通知父应用
            setGlobalState(state, payload) {
                // commit('setGlobalState', payload);
                // commit('emitGlobalState', payload);
                props.setGlobalState(payload);

            },
            // 初始化，只用于mount时同步父应用的数据
            initGlobalState({ commit }, payload) {
                commit('setGlobalState', payload);
            },
        },
        mutations: {
            // setGlobalState(state, payload) {
            //     // eslint-disable-next-line
            //     state = Object.assign(state, payload);
            // },
            // // 通知父应用
            // emitGlobalState(state) {
            //     if (props.setGlobalState) {
            //         props.setGlobalState(state);
            //     }
            // },
        },
    };
    store.registerModule('global', globalModule);
}

export default registerGlobalModule;